// Fonts are bundled with the app (no request to Google Fonts): see @fontsource-variable in package.json.
import "@fontsource-variable/fraunces";
import "@fontsource-variable/inter";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { registerSW } from "virtual:pwa-register";
import { checkForNewBuild } from "./appUpdate.js";

// registerType: "autoUpdate" (in vite.config.js) means updates apply
// silently — no "new version available" prompt for anyone to dismiss or
// ignore. But by default, the browser only checks for a new version on its
// own schedule (roughly once a day) or when the app is fully closed and
// reopened. This checks every 30 minutes instead, so someone who leaves a
// tab open for hours still gets an update reasonably promptly rather than
// being stuck on an old build until they happen to restart the app.
const CHECK_INTERVAL_MS = 30 * 60 * 1000;

// Phones freeze timers while the app is in the background, so the interval alone rarely fires for an installed app.
// Also check right away, and every time the app comes back to the foreground.
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() { updateSW(true); },   // a new version is waiting: activate it and reload
  onRegisteredSW(swUrl, registration) {
    if (!registration) return;
    const check = () => { if (navigator.onLine !== false) { registration.update().catch(() => {}); checkForNewBuild(); } };
    check();
    setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
    window.addEventListener("online", check);
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
